<template>
  <div style="margin: 0 24px">
    <remote-js :src="amapLocaUrl"></remote-js>
    <a-row :gutter="24">
      <a-col :sm="24" :md="12" :xl="10" :style="{ margin: '24px 0' }">
        <a-popover
          v-model="visiblePopover"
          placement="bottomLeft"
          trigger="click"
          @visibleChange="visibleCompanyList"
          overlayClassName="company-popover"
        >
          <template slot="title">
            <a-input
              style="min-width: 222px; margin: 7px 0 8px 0"
              v-model="currentAsrName"
              @change="handleInputChange"
              placeholder="请输入公司名称"
            />
          </template>
          <template slot="content">
            <div class="search-content">
              <p
                class="company-name"
                v-for="(item, index) in companyList"
                :key="index"
                v-text="item.asrName || ''"
                v-show="item.show !== false"
                @click="setCurrentCompany(item)"
              ></p>
            </div>
          </template>
          <a class="ant-dropdown-link">
            {{ currentCompany.asrName }}
            <a-icon type="caret-down" />
          </a>
        </a-popover>
        <span class="closing-data"
          >数据截止至
          {{
            (new Date().getTime() - 60 * 60 * 24 * 1000) | moment("YYYY-MM-DD")
          }}</span
        >
      </a-col>
      <a-col :sm="24" :md="24" :xl="14" :style="{ margin: '24px 0' }">
        <div class="extra-wrapper">
          <!--v-model.number导致点击事件失效-->
          <a-radio-group v-model="currentDateType" @change="selectDateType">
            <a-radio-button value="1">昨日 </a-radio-button>
            <a-radio-button value="2">本周 </a-radio-button>
            <a-radio-button value="3">本月 </a-radio-button>
            <a-radio-button value="4">本年 </a-radio-button>
            <!-- <a-radio-button v-for="(item,index) in indexOpcitnList" :key="index" :value="index+1">{{item}}
          </a-radio-button> -->
          </a-radio-group>
          <a-range-picker
            format="YYYY/MM"
            :value="monthArr"
            :mode="pickerMode"
            :style="{ width: '256px', 'margin-left': '25px' }"
            @openChange="pickerStatus"
            @panelChange="handlePanelChange"
          >
            <a-icon slot="suffixIcon" type="calendar" />
          </a-range-picker>
        </div>
      </a-col>
    </a-row>
    <a-row :gutter="24">
      <a-col
        v-for="(item, index) in statisticsChartData"
        :key="index"
        :sm="24"
        :md="12"
        :xl="6"
        :style="{ marginBottom: '24px' }"
      >
        <chart-card
          :loading="loading"
          :title="item.title"
          :total="item.total"
          :type="item.chartType"
          :dateString="item.dateString"
        >
          <a-tooltip :title="item.tooltip" slot="action">
            <a-icon type="info-circle-o" />
          </a-tooltip>
          <div>
            <mini-area
              v-if="item.chartType == 'area'"
              :color="item.chartColor"
              :tipAlias="item.tipAlias"
              :showTip="item.showTip"
              :chartData="item.chartData || []"
              @cardInfo="changeCardInfo"
            />
            <mini-area
              v-else-if="item.chartType == 'lineArea'"
              type="lineArea"
              :tipAlias="item.tipAlias"
              :color="item.chartColor"
              :chartData="item.chartData || []"
            />
            <mini-bar
              v-else-if="item.chartType == 'bar'"
              :tipAlias="item.tipAlias"
              :color="item.chartColor"
              :chartData="item.chartData || []"
            />
            <mini-progress
              v-else-if="item.chartType == 'progress'"
              :color="item.chartColor"
              :target="item.target"
              :percentage="item.percentage"
              :leftCount="item.leftCount"
              :rightCount="item.rightCount"
              :rightPercentage="item.rightPercentage"
              :rightHoverText="item.rightHoverText"
              :leftHoverText="item.leftHoverText"
              :showTip="item.showTip"
              height="8px"
            />
          </div>
          <template slot="footer">
            <span
              v-for="(footerItem, footerIndex) in item.footerData"
              :key="footerIndex"
              style="margin-right: 16px"
            >
              <trend
                v-if="footerItem.type === 'trend'"
                flag="down"
                style="margin-right: 16px"
                :term="footerItem.label || getChainLabel()"
                :percentage="footerItem.value"
              ></trend>
              <template v-else>
                <span class="footer-label">{{ footerItem.label }}</span>
                <span class="footer-value">{{
                  footerItem.value | NumberFormat
                }}</span>
              </template>
            </span>
          </template>
        </chart-card>
      </a-col>
    </a-row>

    <a-card :loading="false" :bordered="false" :body-style="{ padding: '0' }">
      <div class="salesCard">
        <a-tabs
          default-active-key="1"
          size="large"
          :tab-bar-style="{ marginBottom: '24px', paddingLeft: '16px' }"
          @change="switchTab"
        >
          <a-tab-pane tab="点位分布" key="1">
            <a-row class="row-in-tab">
              <div class="map-wrap map-wrap-index1">
                <div id="map_container" class="map-container"></div>
                <div class="fad-map-info" v-if="(infoBoxShow & 8) == 8">
                  <a-icon type="info-circle" />
                  <span class="info-text"
                    >点位分布: 这段时间内可接广告点位的位置分布</span
                  >
                  <a-icon
                    @click="closeInfoBox(7)"
                    class="info-close"
                    type="close"
                  />
                </div>
                <div class="fad-map-control">
                  <a-icon
                    @click="fullMap(1)"
                    class="map-full-screen"
                    :type="fullFlag == 1 ? 'fullscreen-exit' : 'fullscreen'"
                  />
                  <a-slider
                    vertical
                    :marks="distanceMarks"
                    :step="25"
                    v-model="sliderValue1"
                    @change="sliderChange"
                  />
                  <div>
                    <div class="zoom-btn">
                      <a-icon type="plus" @click="setMapZoom(1, 'plus')" />
                    </div>
                    <div class="zoom-btn">
                      <a-icon type="minus" @click="setMapZoom(1, 'minus')" />
                    </div>
                  </div>
                </div>
              </div>
              <cascade-table
                :columns="columns1"
                :data="tableData1"
                @citySelect="changeMapCity1"
                v-loadList="addList"
                :allNumList="slowAdd"
                ref="tableList"
              ></cascade-table>
            </a-row>
          </a-tab-pane>
          <a-tab-pane tab="点位利用率" key="2">
            <a-row class="row-in-tab">
              <div class="map-wrap map-wrap-index2">
                <div id="map_container2" class="map-container"></div>
                <div class="fad-map-info" v-if="(infoBoxShow & 4) == 4">
                  <a-icon type="info-circle" />
                  <span class="info-text"
                    >点位利用率:
                    这段时间内可接广告点位每天的上刊率与点位填充率的综合平均</span
                  >
                  <a-icon
                    @click="closeInfoBox(11)"
                    class="info-close"
                    type="close"
                  />
                </div>
                <div class="fad-map-control">
                  <a-icon
                    @click="fullMap(2)"
                    class="map-full-screen"
                    :type="fullFlag == 2 ? 'fullscreen-exit' : 'fullscreen'"
                  />
                  <a-slider
                    vertical
                    :marks="distanceMarks"
                    :step="25"
                    v-model="sliderValue2"
                    @change="sliderChange"
                  />
                  <div>
                    <div class="zoom-btn">
                      <a-icon type="plus" @click="setMapZoom(2, 'plus')" />
                    </div>
                    <div class="zoom-btn">
                      <a-icon type="minus" @click="setMapZoom(2, 'minus')" />
                    </div>
                  </div>
                </div>
              </div>
              <cascade-table
                :columns="columns2"
                :data="tableData2"
                :footerAvgData="footerData2"
                tableName="variousRate"
                @citySelect="changeMapCity2"
              ></cascade-table>
            </a-row>
          </a-tab-pane>
          <a-tab-pane tab="点位曝光率" key="3">
            <a-row class="row-in-tab">
              <div class="map-wrap map-wrap-index3">
                <div id="map_container3" class="map-container"></div>
                <div class="fad-map-info" v-if="(infoBoxShow & 2) == 2">
                  <a-icon type="info-circle" />
                  <span class="info-text"
                    >点位曝光量: 每天从可接广告点位经过的人流量</span
                  >
                  <a-icon
                    @click="closeInfoBox(13)"
                    class="info-close"
                    type="close"
                  />
                </div>
                <div class="fad-map-control">
                  <a-icon
                    @click="fullMap(3)"
                    class="map-full-screen"
                    :type="fullFlag == 3 ? 'fullscreen-exit' : 'fullscreen'"
                  />
                  <a-slider
                    vertical
                    :marks="distanceMarks"
                    :step="25"
                    v-model="sliderValue3"
                    @change="sliderChange"
                  />
                  <div>
                    <div class="zoom-btn">
                      <a-icon type="plus" @click="setMapZoom(3, 'plus')" />
                    </div>
                    <div class="zoom-btn">
                      <a-icon type="minus" @click="setMapZoom(3, 'minus')" />
                    </div>
                  </div>
                </div>
              </div>
              <cascade-table
                :columns="columns3"
                :data="tableData3"
                :footerAvgData="footerData3"
                @citySelect="changeMapCity3"
              ></cascade-table>
            </a-row>
          </a-tab-pane>
          <a-tab-pane tab="广告投放" key="4">
            <a-row class="row-in-tab">
              <div class="map-wrap map-wrap-index4">
                <div id="map_container4" class="map-container"></div>
                <div class="fad-map-info" v-if="(infoBoxShow & 1) == 1">
                  <a-icon type="info-circle" />
                  <span class="info-text"
                    >广告投放:
                    这段时间内投放的广告，从创建广告的公司所在地，投向广告投放的各个点位</span
                  >
                  <a-icon
                    @click="closeInfoBox(14)"
                    class="info-close"
                    type="close"
                  />
                </div>
                <div class="fad-map-control">
                  <a-icon
                    @click="fullMap(4)"
                    class="map-full-screen"
                    :type="fullFlag == 4 ? 'fullscreen-exit' : 'fullscreen'"
                  />
                  <a-slider
                    vertical
                    :marks="distanceMarks"
                    :step="25"
                    v-model="sliderValue4"
                    @change="sliderChange"
                  />
                  <div>
                    <div class="zoom-btn">
                      <a-icon type="plus" @click="setMapZoom(4, 'plus')" />
                    </div>
                    <div class="zoom-btn">
                      <a-icon type="minus" @click="setMapZoom(4, 'minus')" />
                    </div>
                  </div>
                </div>
              </div>
              <cascade-table
                :columns="columns4"
                :data="tableData4"
                @citySelect="changeMapCity4"
                @countryDirection="countryDirection"
              ></cascade-table>
            </a-row>
          </a-tab-pane>
        </a-tabs>
      </div>
    </a-card>
  </div>
</template>

<script>
import Vue from "vue";
import api from "@/commomFun/api.js";
import moment from "moment";
import ChartCard from "@/components/Charts/ChartCard.vue";
import MiniArea from "@/components/Charts/MiniArea.vue";
import MiniBar from "@/components/Charts/MiniBar.vue";
import MiniProgress from "@/components/Charts/MiniProgress.vue";
import Trend from "@/components/Charts/Trend.vue";
import $ from "jquery";
import {
  initMap,
  whiteStyle,
} from "@/commomFun/mapCommon.js";
import { getCenterByProvinceName, getCenterByCityName } from "@/commomFun/cityCenter.js";
import { normalizeCityName } from "@/commomFun/index.js";
import cascadeTable from "@/components/index/indexTable.vue";

const DataSet = require("@antv/data-set");

// 点位分布地图数据
let mapData1 = [],
  instanceMap1 = null,
  layer1 = null,
  layer2 = null,
  layer3 = null,
  layer4 = null;
// 点位利用率地图数据, 省市区聚合
let mapData2 = {
  province: [],
  city: [],
  district: [],
  area: [],
};
let instanceMap2 = null;
let map2Overlays = [];
// 点位曝光地图数据
let mapData3 = [];
let instanceMap3 = null;
let dataSet3 = null;
// 广告投放地图数据
let instanceMap4 = null,
  lineLayer1 = null,
  lineLayer2 = null,
  lineLayerView = null;
let mapData4 = {
  cityDirectionList: {},
  countryDirectionList: [],
};
// tab切换地图时判断是否重新加载接口，初始为二进制0000
let flag = 0;
export default {
  name: "index",
  components: {
    "remote-js": {
      render(createElement) {
        return createElement("script", {
          attrs: { type: "text/javascript", src: this.src },
        });
      },
      props: {
        src: { type: String, required: true },
      },
    },
    ChartCard,
    MiniArea,
    MiniBar,
    MiniProgress,
    Trend,
    cascadeTable,
  },
  data() {
    return {
      slowAdd:[],//总数组
      // indexOpcitnList: ['昨日', '本周', '本月', '近一年'],//优化日期快速选择
      infoBoxShow: 15,
      fullFlag: null,
      currentTab: "1",
      visiblePopover: false,
      currentCompany: {},
      currentAsrName: "",
      distanceMarks: {
        0: "1公里",
        25: "2公里",
        50: "5公里",
        75: "10公里",
        100: "20公里",
      },
      scaleArr: [0, 25, 50, 75, 100],
      mapLevel: [14, 13, 12, 11, 10],
      sliderValue1: 100,
      sliderValue2: 100,
      sliderValue3: 100,
      sliderValue4: 100,
      tableData1: [],
      tableData2: [],
      footerData2: {},
      tableData3: [],
      footerData3: {},
      tableData4: [],
      columns1: {
        parent: [
          {
            title: "排名",
            dataIndex: "sort",
            key: "sort",
            align: "center",
            width: 75,
            scopedSlots: { customRender: "sort" },
          },
          {
            title: "城市",
            dataIndex: "cityName",
            key: "cityName",
            align: "center",
            width: 100,
            ellipsis: true,
            scopedSlots: { customRender: "clickEle" },
          },
          {
            title: "网点资源",
            dataIndex: "communityCnt",
            key: "communityCnt",
            align: "center",
            width: 105,
            sorter: (a, b) => a.communityCnt - b.communityCnt,
            scopedSlots: { customRender: "communityCnt" },
          },
          {
            title: "点位",
            dataIndex: "deviceCount",
            key: "deviceCount",
            align: "center",
            width: 100,
            sorter: (a, b) => a.deviceCount - b.deviceCount,
            scopedSlots: { customRender: "deviceCount" },
          },
        ],
        parentStatistics: ["cityName", "communityCnt", "deviceCount"],
        child: [
          {
            dataIndex: "sort",
            key: "sort",
            align: "left",
            width: 75,
            scopedSlots: { title: "backEle" },
          },
          {
            title: "区县",
            dataIndex: "districtName",
            key: "districtName",
            align: "left",
            width: 140,
            ellipsis: true,
            scopedSlots: { customRender: "clickEle" },
          },
          {
            title: "社区",
            dataIndex: "communityCnt",
            key: "communityCnt",
            align: "right",
            width: 105,
            sorter: (a, b) => a.communityCnt - b.communityCnt,
          },
          {
            title: "媒体",
            dataIndex: "deviceCount",
            key: "deviceCount",
            align: "right",
            width: 100,
            sorter: (a, b) => a.deviceCount - b.deviceCount,
          },
        ],
        childStatistics: ["districtName", "communityCnt", "deviceCount"],
        leaf: [
          {
            dataIndex: "sort",
            key: "sort",
            align: "left",
            width: 75,
            scopedSlots: { title: "backEle" },
          },
          {
            title: "小区",
            dataIndex: "communityName",
            key: "communityName",
            align: "left",
            width: 200,
            ellipsis: true,
          },
          {
            title: "媒体",
            dataIndex: "deviceCount",
            key: "deviceCount",
            align: "right",
            width: 145,
            sorter: (a, b) => a.deviceCount - b.deviceCount,
          },
        ],
        leafStatistics: ["communityName", "deviceCount"],
      },
      columns2: {
        parent: [
          {
            title: "排名",
            dataIndex: "sort",
            key: "sort",
            align: "left",
            width: 75,
          },
          {
            title: "城市",
            dataIndex: "cityName",
            key: "cityName",
            align: "left",
            width: 75,
            ellipsis: true,
            scopedSlots: { customRender: "clickEle" },
          },
          {
            title: "上刊率",
            dataIndex: "adSKRate",
            key: "adSKRate",
            align: "right",
            width: 90,
            ellipsis: true,
            sorter: (a, b) => a.adSKRate - b.adSKRate,
            scopedSlots: { customRender: "rate" },
          },
          {
            title: "填充率",
            dataIndex: "fillRate",
            key: "fillRate",
            align: "right",
            width: 90,
            ellipsis: true,
            sorter: (a, b) => a.fillRate - b.fillRate,
            scopedSlots: { customRender: "rate" },
          },
          {
            title: "利用率",
            dataIndex: "uitilizationRate",
            key: "uitilizationRate",
            align: "right",
            width: 90,
            ellipsis: true,
            sorter: (a, b) => a.uitilizationRate - b.uitilizationRate,
            scopedSlots: { customRender: "rate" },
          },
        ],
        parentStatistics: [
          "cityName",
          "adSKRate",
          "fillRate",
          "uitilizationRate",
        ],
        child: [
          {
            dataIndex: "sort",
            key: "sort",
            align: "left",
            width: 75,
            scopedSlots: { title: "backEle" },
          },
          {
            title: "区县",
            dataIndex: "districtName",
            key: "districtName",
            align: "left",
            width: 75,
            ellipsis: true,
            scopedSlots: { customRender: "clickEle" },
          },
          {
            title: "上刊率",
            dataIndex: "adSKRate",
            key: "adSKRate",
            align: "right",
            width: 90,
            ellipsis: true,
            sorter: (a, b) => a.adSKRate - b.adSKRate,
            scopedSlots: { customRender: "rate" },
          },
          {
            title: "填充率",
            dataIndex: "fillRate",
            key: "fillRate",
            align: "right",
            width: 90,
            ellipsis: true,
            sorter: (a, b) => a.fillRate - b.fillRate,
            scopedSlots: { customRender: "rate" },
          },
          {
            title: "利用率",
            dataIndex: "uitilizationRate",
            key: "uitilizationRate",
            align: "right",
            width: 90,
            ellipsis: true,
            sorter: (a, b) => a.uitilizationRate - b.uitilizationRate,
            scopedSlots: { customRender: "rate" },
          },
        ],
        childStatistics: [
          "cityName",
          "adSKRate",
          "fillRate",
          "uitilizationRate",
        ],
        leaf: [
          {
            dataIndex: "sort",
            key: "sort",
            align: "left",
            width: 75,
            scopedSlots: { title: "backEle" },
          },
          {
            title: "小区",
            dataIndex: "communityName",
            key: "communityName",
            align: "left",
            width: 75,
            ellipsis: true,
          },
          {
            title: "上刊率",
            dataIndex: "adSKRate",
            key: "adSKRate",
            align: "right",
            width: 90,
            ellipsis: true,
            sorter: (a, b) => a.adSKRate - b.adSKRate,
            scopedSlots: { customRender: "rate" },
          },
          {
            title: "填充率",
            dataIndex: "fillRate",
            key: "fillRate",
            align: "right",
            width: 90,
            ellipsis: true,
            sorter: (a, b) => a.fillRate - b.fillRate,
            scopedSlots: { customRender: "rate" },
          },
          {
            title: "利用率",
            dataIndex: "uitilizationRate",
            key: "uitilizationRate",
            align: "right",
            width: 90,
            ellipsis: true,
            sorter: (a, b) => a.uitilizationRate - b.uitilizationRate,
            scopedSlots: { customRender: "rate" },
          },
        ],
        leafStatistics: [
          "cityName",
          "adSKRate",
          "fillRate",
          "uitilizationRate",
        ],
      },
      columns3: {
        parent: [
          {
            title: "排名",
            dataIndex: "sort",
            key: "sort",
            align: "left",
            width: 75,
          },
          {
            title: "城市",
            dataIndex: "cityName",
            key: "cityName",
            align: "left",
            width: 95,
            ellipsis: true,
            scopedSlots: { customRender: "clickEle" },
          },
          {
            title: "曝光人次",
            dataIndex: "wfsCnt",
            key: "wfsCnt",
            align: "center",
            width: 125,
            sorter: (a, b) => a.wfsCnt - b.wfsCnt,
            scopedSlots: { customRender: "splitEle" },
          },
          {
            title: "曝光人数",
            dataIndex: "wfsMacCnt",
            key: "wfsMacCnt",
            align: "center",
            width: 125,
            sorter: (a, b) => a.wfsMacCnt - b.wfsMacCnt,
            scopedSlots: { customRender: "splitEle" },
          },
        ],
        parentStatistics: ["cityName", "wfsCnt", "wfsMacCnt"],
        child: [
          {
            dataIndex: "sort",
            key: "sort",
            align: "left",
            width: 75,
            scopedSlots: { title: "backEle" },
          },
          {
            title: "区县",
            dataIndex: "districtName",
            key: "districtName",
            align: "left",
            width: 95,
            ellipsis: true,
            scopedSlots: { customRender: "clickEle" },
          },
          {
            title: "曝光人次",
            dataIndex: "wfsCnt",
            key: "wfsCnt",
            align: "right",
            width: 125,
            sorter: (a, b) => a.wfsCnt - b.wfsCnt,
            scopedSlots: { customRender: "splitEle" },
          },
          {
            title: "曝光人数",
            dataIndex: "wfsMacCnt",
            key: "wfsMacCnt",
            align: "right",
            width: 125,
            sorter: (a, b) => a.wfsMacCnt - b.wfsMacCnt,
            scopedSlots: { customRender: "splitEle" },
          },
        ],
        childStatistics: ["districtName", "wfsCnt", "wfsMacCnt"],
        leaf: [
          {
            dataIndex: "sort",
            key: "sort",
            align: "left",
            width: 75,
            scopedSlots: { title: "backEle" },
          },
          {
            title: "小区",
            dataIndex: "communityName",
            key: "communityName",
            align: "left",
            width: 115,
            ellipsis: true,
          },
          {
            title: "曝光人次",
            dataIndex: "wfsCnt",
            key: "wfsCnt",
            align: "right",
            width: 115,
            sorter: (a, b) => a.wfsCnt - b.wfsCnt,
            scopedSlots: { customRender: "splitEle" },
          },
          {
            title: "曝光人数",
            dataIndex: "wfsMacCnt",
            key: "wfsMacCnt",
            align: "right",
            width: 115,
            sorter: (a, b) => a.wfsMacCnt - b.wfsMacCnt,
            scopedSlots: { customRender: "splitEle" },
          },
        ],
        leafStatistics: ["communityName", "wfsCnt", "wfsMacCnt"],
      },
      columns4: {
        parent: [
          {
            title: "排名",
            dataIndex: "sort",
            key: "sort",
            align: "left",
            width: 75,
          },
          {
            title: "城市",
            dataIndex: "cityName",
            key: "cityName",
            align: "left",
            width: 175,
            ellipsis: true,
            scopedSlots: { customRender: "clickEle" },
          },
          {
            title: "广告数量",
            dataIndex: "cityPlanCnt",
            key: "cityPlanCnt",
            align: "center",
            width: 170,
            sorter: (a, b) => a.cityPlanCnt - b.cityPlanCnt,
          },
        ],
        parentStatistics: ["cityName", "cityPlanCnt"],
        child: [
          {
            dataIndex: "sort",
            key: "sort",
            align: "left",
            width: 75,
            scopedSlots: { title: "backEle" },
          },
          {
            title: "区县",
            dataIndex: "districtName",
            key: "districtName",
            align: "left",
            width: 175,
            ellipsis: true,
            scopedSlots: { customRender: "clickEle" },
          },
          {
            title: "广告数量",
            dataIndex: "distPlanCnt",
            key: "distPlanCnt",
            align: "right",
            width: 170,
            sorter: (a, b) => a.distPlanCnt - b.distPlanCnt,
          },
        ],
        childStatistics: ["districtName", "distPlanCnt"],
        leaf: [
          {
            dataIndex: "sort",
            key: "sort",
            align: "left",
            width: 75,
            scopedSlots: { title: "backEle" },
          },
          {
            title: "小区",
            dataIndex: "communityName",
            key: "communityName",
            align: "left",
            width: 175,
            ellipsis: true,
          },
          {
            title: "广告数量",
            dataIndex: "comPlanCnt",
            key: "comPlanCnt",
            align: "right",
            width: 170,
            sorter: (a, b) => a.comPlanCnt - b.comPlanCnt,
          },
        ],
        leafStatistics: ["communityName", "comPlanCnt"],
      },
      // 公司列表
      companyList: [],
      currentDateType: "1",
      // 月份区间数组
      monthArr: [],
      pickerMode: ["month", "month"],
      loading: true,

      // 上半部分统计数据: [可投点位数 广告计划数 上刊率 填充率销售收入 新增客户数 门出入人流量 刷脸开门人数]
      statisticsChartData: {
        enableMedia: {
          title: "可接广告点位数",
          tooltip:
            "可接广告点位是指达到可接广告放标准的点位，不包含待安装、故障、禁用以及激活等不可接广告点位",
          chartType: "area",
          chartColor: "#6B00FF",
          tipAlias: "可接广告点位数量",
          showTip: false,
          total: "",
          dateString: "",
          chartData: [],
          footerData: [
            {
              label: "在线",
              value: "",
            },
            {
              label: "离线",
              value: "",
            },
            {
              label: "异常",
              value: "",
            },
          ],
        },
        adPlan: {
          title: "广告订单数",
          tooltip:
            "在这段时间内开始投放的广告，包含待投放、投放中以及已结束的广告",
          chartType: "bar",
          chartColor: "#1890FF",
          tipAlias: "广告订单数量",
          total: 0,
          chartData: [],
          footerData: [
            {
              label: "在投计划",
              value: "",
            },
            {
              label: "在审计划",
              value: "",
            },
          ],
        },
        skRate: {
          title: "空置率",
          tooltip: "没有播放商业广告的点位，占总可接广告点位中的比重",
          chartType: "progress",
          chartColor: "#33C9C9",
          tipAlias: "空置率",
          total: 0,
          percentage: 0,
          leftCount: 0,
          rightCount: 0,
          rightPercentage: 0,
          leftHoverText: "",
          rightHoverText: "",
          showTip: false,
          footerData: [
            {
              type: "trend",
              label: "",
              value: null,
            },
            {
              label: "上刊点位",
              value: "",
            },
          ],
        },
        fillRate: {
          title: "填充率",
          tooltip:
            "拥有份额的点位每天有广告在投放的，播放广告的总时长占总有效播放时长（15小时）的比例",
          chartType: "progress",
          chartColor: "#73D13D",
          tipAlias: "填充率",
          total: 0,
          percentage: 0,
          leftCount: 0,
          rightCount: 0,
          rightPercentage: 0,
          leftHoverText: "",
          rightHoverText: "",
          target: 0,
          showTip: true,
          footerData: [
            {
              type: "trend",
              label: "",
              value: null,
            },
            {
              label: "平均时长",
              value: "0s",
            },
          ],
        },
        income: {
          title: "销售收入",
          tooltip: "当前日期内开始的计划销售收入",
          chartType: "area",
          chartColor: "#003CFF",
          tipAlias: "销售收入",
          total: 0,
          chartData: [],
          footerData: [
            {
              type: "trend",
              label: "",
              value: null,
            },
          ],
        },
        newCustomers: {
          title: "新增客户数",
          tooltip: "这段时间内，在系统上新建的客户",
          chartType: "bar",
          chartColor: "#13C2C2",
          tipAlias: "新增客户",
          total: 0,
          footerData: [
            {
              type: "trend",
              label: "",
              value: null,
            },
          ],
        },
        doorFlowrate: {
          title: "门出入人流量",
          tooltip:
            "近距离曝光总人次（线上开门次数+实体卡开门次数+陌生人脸抓拍次数）",
          chartType: "lineArea",
          chartColor: "rgb(211, 232, 255)",
          tipAlias: "人流量",
          total: 0,
          chartData: [],
          footerData: [
            {
              type: "trend",
              label: "",
              value: null,
            },
          ],
        },
        openDoor: {
          title: "刷脸开门次数",
          tooltip: "通过人脸识别成功开门的人次",
          chartType: "lineArea",
          chartColor: "rgb(211, 232, 255)",
          tipAlias: "开门人数",
          total: 0,
          chartData: [],
          footerData: [
            {
              type: "trend",
              label: "",
              value: null,
            },
          ],
        },
      },
    };
  },
  beforeCreate() {
    /* 高德地图SDK已在index.html中加载 */
  },
  created() {
    this.getCompanyList();
  },
    destroyed(){
        // window.removeEventListener('scroll', this.getScroll);
    },
  mounted() {
    // let that = this;
    // this.getScroll();
    setTimeout(() => {
      flag = 0;
      instanceMap1 = null;
      instanceMap2 = null;
      instanceMap3 = null;
      instanceMap4 = null;
      this.switchTab("1");
      this.loading = false;
    }, 2000);
  },
    directives:{
    loadList:{
      bind:function(el,binding,vnode){
          const e = el.querySelector('.ant-table-body');
          e.addEventListener('scroll',function(e){
             const scrollDistance = this.scrollHeight - this.scrollTop - this.clientHeight;
             if(scrollDistance<1000){
             vnode.context.addList()
             }
          })
      }
     
    }
  },
  computed: {
    amapLocaUrl() {
      return `https://webapi.amap.com/loca?v=2.0.0&key=${process.env.VUE_APP_AMAP_KEY}`
    }
  },
  methods: {
    addList(){
      let length = this.tableData1.length;//当前数组的列表的长度
      if(length>=this.slowAdd.length){//如果当前长度大于 所有的 那么结束
         return
      }else if(length+200>this.slowAdd.length){//如果当前长度+200 大于总长 那么就获取他剩下的有多少个在去截取
        let num = this.slowAdd.length-length;
        let newArr = this.slowAdd.slice(length,length+num)
            this.tableData1.push(...newArr);
      }else{//正常的
         let arr = this.slowAdd.slice(length,length+200);//截取到到当前长度+200条数据
         this.tableData1.push(...arr);
      }
       this.bubbleSort(this.tableData1, "deviceCount", "sort");
    },
    // 日期控制
    // disabledDate(current) {
    //   return current && current > moment().endOf('day');
    // },
    // 地图全屏
    closeInfoBox(baseNum) {
      this.infoBoxShow &= baseNum;
    },
    fullMap(key) {
      let tempInstance = null,
        obj = null;
      switch (key) {
        case 1:
          tempInstance = instanceMap1;
          obj = $(".map-wrap-index1");
          if (obj.hasClass("map-wrap-full")) {
            obj.removeClass("map-wrap-full");
            $("body").css({ overflow: "auto" });
            this.fullFlag = null;
          } else {
            $(".map-wrap-index1").addClass("map-wrap-full");
            $("body").css({ overflow: "hidden" });
            this.fullFlag = key;
          }
          break;
        case 2:
          tempInstance = instanceMap2;
          obj = $(".map-wrap-index2");
          if (obj.hasClass("map-wrap-full")) {
            obj.removeClass("map-wrap-full");
            $("body").css({ overflow: "auto" });
            setTimeout(() => {
              tempInstance.setZoom(5);
            }, 100);
            this.fullFlag = null;
          } else {
            $(".map-wrap-index2").addClass("map-wrap-full");
            $("body").css({ overflow: "hidden" });
            setTimeout(() => {
              tempInstance.setZoom(6);
            }, 100);
            this.fullFlag = key;
          }
          break;
        case 3:
          tempInstance = instanceMap3;
          obj = $(".map-wrap-index3");
          if (obj.hasClass("map-wrap-full")) {
            obj.removeClass("map-wrap-full");
            $("body").css({ overflow: "auto" });
            tempInstance.setZoom(5);
            this.fullFlag = null;
          } else {
            $(".map-wrap-index3").addClass("map-wrap-full");
            $("body").css({ overflow: "hidden" });
            tempInstance.setZoom(6);
            this.fullFlag = key;
          }
          break;
        case 4:
          tempInstance = instanceMap4;
          obj = $(".map-wrap-index4");
          if (obj.hasClass("map-wrap-full")) {
            obj.removeClass("map-wrap-full");
            $("body").css({ overflow: "auto" });
            this.fullFlag = null;
          } else {
            $(".map-wrap-index4").addClass("map-wrap-full");
            $("body").css({ overflow: "hidden" });
            this.fullFlag = key;
          }
          break;
        default:
          return;
          break;
      }
    },
    // 根据缩放级别返回滑动条比例
    getSliderValue(zoomLevel) {
      if (zoomLevel > 14) {
        return 0;
      } else if (zoomLevel < 10) {
        return 100;
      } else {
        return this.scaleArr[this.mapLevel.indexOf(~~zoomLevel)];
      }
    },
    // 放大或缩小地图
    setMapZoom(key, type) {
      let tempInstance = null;
      switch (key) {
        case 1:
          tempInstance = instanceMap1;
          break;
        case 2:
          tempInstance = instanceMap2;
          break;
        case 3:
          tempInstance = instanceMap3;
          break;
        case 4:
          tempInstance = instanceMap4;
          break;
        default:
          return;
          break;
      }
      if (type === "plus") {
        tempInstance.zoomIn();
      } else if (type === "minus") {
        tempInstance.zoomOut();
      }
    },
    // 地图根据滑块缩放
    sliderChange(val) {
      let level = this.mapLevel[this.scaleArr.indexOf(val * 1)];
      switch (this.currentTab) {
        case "1":
          instanceMap1.setZoom(level);
          break;
        case "2":
          instanceMap2.setZoom(level);
          break;
        case "3":
          instanceMap3.setZoom(level);
          break;
        case "4":
          instanceMap4.setZoom(level);
          break;
        default:
          break;
      }
    },
    // 返回环比文案
    getChainLabel() {
      let chainText = "";
      switch (this.currentDateType) {
        case "1":
          chainText = "环比昨日";
          break;
        case "2":
          chainText = "环比上周";
          break;
        case "3":
          chainText = "环比上月";
          break;
        case "4":
          chainText = "环比上年";
          break;
        default:
          break;
      }
      return chainText;
    },
    // 选择公司
    setCurrentCompany(item) {
      if (this.currentAsrName != item.asrName) {
        this.currentCompany = item;
        this.currentAsrName = item.asrName;
        this.getReport();
      }
      this.visiblePopover = false;
    },
    // 输入框搜索
    handleInputChange(val = "") {
      this.companyList.forEach((item) => {
        if (item.asrName.indexOf(this.currentAsrName) === -1) {
          item.show = false;
        } else {
          item.show = true;
        }
      });
    },
    // 获取公司列表
    getCompanyList() {
      api
        .getApiSpecil(`/report/homepage/getAscrInfoList`)
        .then((res) => {
          if (res && res.data.code == 200) {
            Array.isArray(res.data.data) && (this.companyList = res.data.data);
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .finally(() => {
          // 超管可以查看全部
          if (JSON.parse(sessionStorage.getItem("userInfo")).userType == "1") {
            this.companyList.unshift({
              asrId: "",
              asrName: "全部",
            });
          }
          this.currentCompany = this.companyList[0];
          this.getReport();
        });
    },
    visibleCompanyList(status) {
      if (status === true) {
        this.currentAsrName = "";
        this.handleInputChange();
      }
    },
    selectDateType(type) {
      // 激活的radio不会重复点击触发该事件
      this.monthArr = [];
      this.getReport();
    },
    pickerStatus(status) {
      if (status === false && this.monthArr.length == 2) {
        this.currentDateType = "";
        this.getReport();
      }
    },

    handlePanelChange(value, mode) {
      this.monthArr = value;
      // this.mode2 = [mode[0] === 'date' ? 'month' : mode[0], mode[1] === 'date' ? 'month' : mode[1]];
    },

    // 切换card信息
    changeCardInfo(showInfo) {
      Object.assign(this.statisticsChartData.enableMedia, {
        dateString: showInfo.x || "",
        total: showInfo.y || 0,
        footerData: [
          {
            label: "在线",
            value: showInfo.onLineCount,
          },
          {
            label: "离线",
            value: showInfo.offLineCount,
          },
          {
            label: "异常",
            value: showInfo.unusualCount,
          },
        ],
      });
    },

    /**
     * 获取首页的年广告计划数报表
      【GET】 /report/homepage/getAdPlaCountnReport

      获取首页的上刊率报表
      【GET】 /report/homepage/getAdPlanSKRateReport

      获取首页的空置率报表
      【GET】 /report/homepage/getAdPlanKZRateReport

      获取首页的填充率报表
      【GET】 /report/homepage/getFillingRateReport

      获取首页的出入人流量
      【GET】 /report/homepage/getVisitorsFlowReport


      获取首页的客户报表
      【GET】 /report/homepage/getCustomerReport
      
      获取首页的销售收入报表
      【GET】 /report/homepage/getSaleIncomeReport

      获取点位利用率报表
      【GET】 /report/homepage/getVariousRateReport
     */
    getReport(paramsMap) {
      let userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
      let requestMap = new Map([
        [
          "getDeviceStatusReport",
          {
            type: "area",
            index: "enableMedia",
            dataColumn: "chartData",
            apiColumn: "dayDataList",
          },
        ],
        [
          "getAdPlaCountnReport",
          {
            type: "bar",
            index: "adPlan",
            dataColumn: "chartData",
            apiColumn: "dateList",
          },
        ],
        [
          "getAdPlanKZRateReport",
          {
            type: "progress",
            index: "skRate",
          },
        ],
        [
          "getFillingRateReport",
          {
            type: "progress",
            index: "fillRate",
          },
        ],
        [
          "getVisitorsFlowReport",
          {
            type: "lineArea",
            dataColumn: "chartData",
            apiColumn: "dayFaceDataList",
          },
        ],
        [
          "getSaleIncomeReport",
          {
            type: "area",
            index: "income",
            dataColumn: "chartData",
            apiColumn: "dayDataList",
          },
        ],
        [
          "getCustomerReport",
          {
            type: "bar",
            index: "newCustomers",
            dataColumn: "chartData",
            apiColumn: "monthReportList",
          },
        ],
      ]);
      if (paramsMap) {
        requestMap = paramsMap;
      } else {
        // 没有传参时，重置flag
        flag = 0;
        switch (this.currentTab) {
          case "1":
            requestMap.set("getDeviceCountReport", { type: "map" });
            break;
          case "2":
            requestMap.set("getVariousRateReport", { type: "map" });
            break;
          case "3":
            requestMap.set("getWFSCountReport", { type: "map" });
            break;
          case "4":
            requestMap.set("getOnPubPlanReport", { type: "map" });
            break;
          default:
            break;
        }
      }
      let params = {
        asrId: this.currentCompany.asrId,
        startTime:
          this.monthArr[0] &&
          this.monthArr[0].startOf("month").format("YYYY/MM/DD"),
        endTime:
          this.monthArr[1] &&
          this.monthArr[1].endOf("month").format("YYYY/MM/DD"),
        dateType: this.currentDateType,
      };
      requestMap.forEach((value, varUrl, map) => {
        api.getApiSpecil(`/report/homepage/${varUrl}`, params).then((res) => {
          if (res && res.data.code == 200 && res.data.data) {
            if (
              value.type == "area" ||
              value.type == "bar" ||
              value.type == "lineArea"
            ) {
              let resData = res.data.data;
              let chartData = resData[value.apiColumn] || [];
              let tempXY = [];
              switch (varUrl) {
                // 可投点位的报表（卡片1）
                case "getDeviceStatusReport":
                  let resDataLength = (resData||[]).length
                  resData.forEach((item) => {
                    tempXY.push({
                      x: item.date,
                      y: item.totalDeviceCount || 0,
                      onLineCount: item.onLineCount,
                      offLineCount: item.offLineCount,
                      unusualCount: item.unusualCount,
                    });
                  });
                  Object.assign(this.statisticsChartData.enableMedia, {
                    dateString: resDataLength?resData[resDataLength - 1].date || "":"",
                    total: resDataLength?resData[resDataLength - 1].totalDeviceCount || 0:"",
                    chartData: tempXY,
                    footerData: [
                      {
                        label: "在线",
                        value: resDataLength?resData[resDataLength - 1].onLineCount:"",
                      },
                      {
                        label: "离线",
                        value: resDataLength?resData[resDataLength - 1].offLineCount:"",
                      },
                      {
                        label: "异常",
                        value: resDataLength?resData[resDataLength - 1].unusualCount:""
                      },
                    ],
                  });
                  break;
                // 广告计划数（卡片2）
                case "getAdPlaCountnReport":
                  chartData.forEach((item) => {
                    // 在投: launchCount
                    // 在审: verifyCount
                    tempXY.push({
                      x: item.date,
                      y: item.count || 0,
                    });
                  });
                  Object.assign(this.statisticsChartData.adPlan, {
                    total: resData.totalCount || 0,
                    chartData: tempXY,
                    footerData: [
                      {
                        label: "在投计划",
                        value: resData.launchCount,
                      },
                      {
                        label: "在审计划",
                        value: resData.verifyCount,
                      },
                    ],
                  });
                  break;

                // 门出入人流量（卡片7） 刷脸开门人数（卡片8）
                case "getVisitorsFlowReport":
                  let flowTemp = [];
                  chartData.forEach((item) => {
                    tempXY.push({
                      x: item.localDate,
                      y: item.faceOpenCount,
                    });
                    flowTemp.push({
                      x: item.localDate,
                      y: item.nearCount,
                    });
                  });
                  Object.assign(this.statisticsChartData.doorFlowrate, {
                    total: resData.totalNearCount || 0,
                    chartData: flowTemp,
                    footerData: [
                      {
                        type: "trend",
                        label: this.getChainLabel(),
                        value: resData.nearIncreRate,
                      },
                    ],
                  });
                  Object.assign(this.statisticsChartData.openDoor, {
                    total: resData.totalFaceOpenCount || 0,
                    chartData: tempXY,
                    footerData: [
                      {
                        type: "trend",
                        label: this.getChainLabel(),
                        value: resData.faceOpenIncreRate,
                      },
                    ],
                  });
                  break;
                // 销售收入（卡片5）
                case "getSaleIncomeReport":
                  chartData.forEach((item) => {
                    tempXY.push({
                      x: item.time,
                      y: item.income,
                    });
                  });
                  Object.assign(this.statisticsChartData.income, {
                    total: resData.totalIncome || 0,
                    chartData: tempXY,
                    footerData: [
                      {
                        type: "trend",
                        label: this.getChainLabel(),
                        value: resData.incrRate,
                      },
                    ],
                  });
                  break;
                // 新增客户数（卡片6）
                case "getCustomerReport":
                  chartData.forEach((item) => {
                    tempXY.push({
                      x: item.date,
                      y: item.monthCnt,
                    });
                  });
                  Object.assign(this.statisticsChartData.newCustomers, {
                    total: resData.totalCnt || 0,
                    chartData: tempXY,
                    footerData: [
                      {
                        type: "trend",
                        label: this.getChainLabel(),
                        value: resData.increRate,
                      },
                    ],
                  });
                  break;
                default:
                  // console.error("!");
                  break;
              }
            } else if (value.type == "progress") {
              let progressData = res.data.data;
              if (!progressData) return;
              let tempObj = {};
              switch (varUrl) {
                case "getAdPlanKZRateReport":
                  tempObj = {
                    total: progressData.onPublishRate || 0,
                    // 上刊率
                    percentage: progressData.onPublishRate || 0,
                    // 上刊数量
                    leftCount: progressData.onPublishCount,
                    // 下刊数量
                    // rightCount: progressData.offPublishCount,
                    // 下刊率
                    rightPercentage: progressData.offPublishRate,
                    leftHoverText: `${progressData.onPublishRate || "0"}% ，${
                      progressData.onPublishCount || "0"
                    }台`,
                    // rightHoverText: `${progressData.offPublishRate || "0"}% ，${
                    //   progressData.offPublishCount || "0"
                    // }台`,
                    target: progressData.thresholdRate,
                    footerData: [
                      {
                        type: "trend",
                        label: this.getChainLabel(),
                        value: progressData.incrRate,
                      },
                      {
                        label: "上刊点位",
                        value: progressData.onPublishCount || "--",
                      },
                    ],
                  };
                  break;
                case "getFillingRateReport":
                  tempObj = {
                    total: progressData.fillRate || 0,
                    // 填充率
                    percentage: progressData.fillRate || 0,
                    // 填充秒数
                    leftCount: progressData.fillSecond,
                    // 未填充秒数
                    rightCount: progressData.unFillSecond,
                    // 未填充率
                    rightPercentage: progressData.unFillRate,
                    target: progressData.thresholdRate,
                    leftHoverText: `${progressData.fillRate || "0"}% ，${
                      progressData.fillSecond || "0"
                    }秒`,
                    rightHoverText: `${progressData.unFillRate || "0"}% ，${
                      progressData.unFillSecond || "0"
                    }秒`,
                    footerData: [
                      {
                        type: "trend",
                        label: this.getChainLabel(),
                        value: progressData.incrRate,
                      },
                      {
                        label: "平均时长",
                        value: progressData.fillSecond + "s" || "--",
                      },
                    ],
                  };
                  break;
                default:
                  // console.error("!");
                  break;
              }
              Object.assign(this.statisticsChartData[value.index], tempObj);
            } else {
              // 地图和表格原始数据
              let tempMapData = res.data.data;
              switch (varUrl) {
                // 点位曝光率
                case "getWFSCountReport":
                  if (
                    tempMapData &&
                    Array.isArray(tempMapData.provinceReportList)
                  ) {
                    let configMap = [
                      {
                        key: "provinceReportList",
                        value: [],
                      },
                      {
                        key: "cityReportList",
                        value: ["cityId", "cityName", "wfsCnt", "wfsMacCnt"],
                      },
                      {
                        key: "districtReportList",
                        value: [
                          "districtId",
                          "districtName",
                          "wfsCnt",
                          "wfsMacCnt",
                        ],
                      },
                      {
                        key: "communityReportList",
                        value: [
                          "communityId",
                          "communityName",
                          "wfsCnt",
                          "wfsMacCnt",
                        ],
                      },
                    ];
                    mapData3 = [];
                    this.tableData3 = this.commonTableProcess(
                      configMap,
                      tempMapData,
                      (leafItem) => {
                        mapData3.push({
                          geometry: {
                            type: "Point",
                            coordinates: [
                              parseFloat(leafItem.lng),
                              parseFloat(leafItem.lat),
                            ],
                          },
                          count: (leafItem.wfsCnt || 0) / 500,
                        });
                      }
                    );

                    // 由于城市被嵌套在省份中，城市在前端重新排序
                    this.bubbleSort(this.tableData3, "wfsCnt", "sort");
                    dataSet3 && dataSet3.set(mapData3);
                    Object.assign(this.footerData3, {
                      wfsCnt: tempMapData.totalWfsCnt,
                      wfsMacCnt: tempMapData.totalWfsMacCnt,
                    });
                  }
                  break;
                // 点位利用率
                case "getVariousRateReport":
                  if (
                    tempMapData &&
                    Array.isArray(tempMapData.provinceReportList)
                  ) {
                    let configMap = [
                      {
                        key: "provinceReportList",
                        value: [],
                        cluster: "mapData2",
                      },
                      {
                        key: "cityReportList",
                        value: [
                          "cityId",
                          "cityName",
                          "adSKRate",
                          "fillRate",
                          "uitilizationRate",
                        ],
                        cluster: true,
                      },
                      {
                        key: "districtReportList",
                        value: [
                          "districtId",
                          "districtName",
                          "adSKRate",
                          "fillRate",
                          "uitilizationRate",
                        ],
                        cluster: true,
                      },
                      {
                        key: "communityReportList",
                        value: [
                          "communityId",
                          "communityName",
                          "adSKRate",
                          "fillRate",
                          "uitilizationRate",
                        ],
                      },
                    ];
                    this.tableData2 = this.commonTableProcess(
                      configMap,
                      tempMapData
                    );
                    this.bubbleSort(
                      this.tableData2,
                      "uitilizationRate",
                      "sort"
                    );
                    Object.assign(this.footerData2, {
                      adSKRate: tempMapData.totalAvgSKRate,
                      fillRate: tempMapData.totalAvgFillRate,
                      uitilizationRate: tempMapData.totalAvgUtilizaionRate,
                    });
                  }
                  instanceMap2 && this.pointUtilization();
                  // console.log("map2", this.tableData2, mapData2);
                  break;
                // 点位分布
                case "getDeviceCountReport":
                  if (
                    tempMapData &&
                    Array.isArray(tempMapData.provinceReportList)
                  ) {
                    let configMap = [
                      {
                        key: "provinceReportList",
                        value: [],
                      },
                      {
                        key: "cityReportList",
                        value: [
                          "cityId",
                          "cityName",
                          "deviceCount",
                          "communityCnt",
                        ],
                      },
                      {
                        key: "districtReportList",
                        value: [
                          "districtId",
                          "districtName",
                          "deviceCount",
                          "communityCnt",
                        ],
                      },
                      {
                        key: "communityReportList",
                        value: ["communityId", "communityName", "deviceCount"],
                      },
                    ];
                    mapData1 = [];
                    // let arr = [] //this.tableData1
                  this.slowAdd  = this.commonTableProcess(
                      configMap,
                      tempMapData,
                      (leafItem) => {
                        mapData1.push({
                          geometry: {
                            type: "Point",
                            coordinates: [
                              parseFloat(leafItem.lng),
                              parseFloat(leafItem.lat),
                            ],
                          },
                          properties: {
                            time: Math.random() * 100,
                            // count: Math.random() * 100,
                            count: leafItem.deviceCount || 0,
                          },
                        });
                      }
                    );
                    console.log(this.slowAdd.length);
                    // let num = [...]
                    // console.log(num);
                    this.tableData1 = this.slowAdd.slice(0,200)
                    this.bubbleSort(this.tableData1, "deviceCount", "sort");
                    if (layer1 && layer2 && layer3 && layer4) {
                      layer1.setData(mapData1);
                      // layer2.setData(mapData1);
                      layer3.setData(mapData1);
                      layer4.setData(mapData1);
                      instanceMap1.centerAndZoom(
                        new AMap.LngLat(105.348145, 28.165926),
                        5
                      );
                    }
                  }
                  
                  // console.log("map1", this.tableData1, mapData1);
                  break;
                // 广告投放
                case "getOnPubPlanReport":
                  if (
                    tempMapData &&
                    Array.isArray(tempMapData.provinceReportList)
                  ) {
                    let configMap = [
                      {
                        key: "provinceReportList",
                        value: [],
                      },
                      {
                        key: "cityReportList",
                        value: ["cityId", "cityName", "cityPlanCnt"],
                      },
                      {
                        key: "districtReportList",
                        value: ["districtId", "districtName", "distPlanCnt"],
                      },
                      {
                        key: "communityReportList",
                        value: ["communityId", "communityName", "comPlanCnt"],
                      },
                    ];
                    this.tableData4 = this.commonTableProcess(
                      configMap,
                      tempMapData
                    );
                    this.bubbleSort(this.tableData4, "cityPlanCnt", "sort");
                    // 广告投放地图数据
                    if (tempMapData) {
                      mapData4 = {
                        cityDirectionList: {},
                        countryDirectionList: [],
                      };
                      // 城市视角
                      let cityDirectionList = tempMapData.cityDirectionList;
                      // 全国视角
                      let countryDirectionList =
                        tempMapData.countryDirectionList;

                      for (let key in cityDirectionList) {
                        let value = cityDirectionList[key];
                        if (Array.isArray(value)) {
                          mapData4.cityDirectionList[key] = [];
                          value.forEach((item) => {
                            if (
                              item &&
                              item.endLat > 0 &&
                              item.endLng > 0 &&
                              item.startLng > 0 &&
                              item.startLat > 0
                            ) {
                              let line = {
                                startPoint: [item.startLng, item.startLat],
                                endPoint: [item.endLng, item.endLat],
                              };
                              mapData4.cityDirectionList[key].push(line);
                            }
                          });
                        }
                      }

                      if (Array.isArray(countryDirectionList)) {
                        countryDirectionList.forEach((item) => {
                          if (
                            item &&
                            item.endLat > 0 &&
                            item.endLng > 0 &&
                            item.startLng > 0 &&
                            item.startLat > 0
                          ) {
                            let line = {
                              startPoint: [item.startLng, item.startLat],
                              endPoint: [item.endLng, item.endLat],
                            };
                            mapData4.countryDirectionList.push(line);
                          }
                        });
                      }
                      console.log("广告投放地图数据", tempMapData, mapData4);
                    }
                    if (instanceMap4) {
                      this.adPush(mapData4["countryDirectionList"]);
                    }
                  }
                  break;
              }
            }
          } else {
            try {
              console.error(varUrl, res.data.msg);
            } catch (error) {}
          }
        });
      });
    },
    /**
     * 处理地图数据的公共方法
     *
     */
    commonTableProcess(configMap, dataSource, callBack) {
      let resTableData = [];
      // 第一层数据
      let first = configMap[0].key;
      let cluster = false;
      let clusterData = null;
      let color = null;
      let size = null;
      // 暂时只有点位利用率地图是聚合的
      if (configMap[0].cluster == "mapData2") {
        cluster = true;
        size = { 0.25: "40px", 0.55: "45px", 0.85: "50px", 1.0: "55px" };
      }
      dataSource[first].forEach((i) => {
        // 点位利用率（省份分组）
        if (cluster && i.provinceName) {
          mapData2.province.push({
            provinceName: i.provinceName,
            // 上刊率决定大小adSKRate
            // 填充率决定颜色fillRate
            size:
              i.adSKRate > 85
                ? size[1.0]
                : i.adSKRate < 55
                ? size[0.25]
                : i.adSKRate < 30
                ? size[0.55]
                : size[0.85],
            // 平均利用率
            uitilizationRate: i.uitilizationRate,
            cityCenter: getCenterByProvinceName(
              i.provinceName
            ),
            click: (e) => {
              // 箭头函数this指向外层
              // 切换到城市聚合
              instanceMap2.setCenter([e.target.cityCenter.lng, e.target.cityCenter.lat]);
              instanceMap2.setZoom(10);
            },
          });
        }
        // 第二层数据
        let second = configMap[1].key;
        if (Array.isArray(i[second])) {
          i[second].forEach((j, index) => {
            if (cluster && j.cityName) {
              mapData2.city.push({
                cityName: j.cityName,
                size:
                  i.adSKRate > 85
                    ? size[1.0]
                    : j.adSKRate < 55
                    ? size[0.25]
                    : j.adSKRate < 30
                    ? size[0.55]
                    : size[0.85],

                // 平均利用率
                uitilizationRate: j.uitilizationRate,
                cityCenter: getCenterByCityName(j.cityName),
                click: (e) => {
                  instanceMap2.setCenter([e.target.cityCenter.lng, e.target.cityCenter.lat]);
                  instanceMap2.setZoom(11);
                },
              });
            }
            let column2 = configMap[1].value;
            let tempParent = {};
            column2.forEach((item) => {
              tempParent[item] = j[item];
            });
            // 第三层数据
            let third = configMap[2].key;
            if (Array.isArray(j[third])) {
              tempParent[third] = [];
              j[third].forEach((k, kIndex) => {
                let districtCenter = null;
                if (
                  Array.isArray(k.communityReportList) &&
                  k.communityReportList.length > 0
                ) {
                  districtCenter = k.communityReportList[0];
                  districtCenter = {
                    lng: districtCenter.lng,
                    lat: districtCenter.lat,
                  };
                }
                if (cluster && districtCenter.lng && districtCenter.lat) {
                  mapData2.district.push({
                    districtName: k.districtName,
                    size:
                      i.adSKRate > 85
                        ? size[1.0]
                        : k.adSKRate < 55
                        ? size[0.25]
                        : k.adSKRate < 30
                        ? size[0.55]
                        : size[0.85],
                    // 平均利用率
                    uitilizationRate: k.uitilizationRate,
                    // 区县经纬度用小区代替
                    cityCenter: districtCenter,
                    click: (e) => {
                      instanceMap2.setCenter([e.target.cityCenter.lng, e.target.cityCenter.lat]);
                      instanceMap2.setZoom(13);
                    },
                  });
                }
                let column3 = configMap[2].value;
                let tempChild = {};
                column3.forEach((item) => {
                  tempChild[item] = k[item];
                });
                // tempChild.key = kIndex;
                // tempChild.sort = kIndex + 1;
                // 第四层数据
                let forth = configMap[3].key;
                if (Array.isArray(k[forth])) {
                  tempChild[forth] = [];
                  k[forth].forEach((l, lIndex) => {
                    if (cluster) {
                      mapData2.area.push({
                        communityName: l.communityName,
                        size:
                          i.adSKRate > 85
                            ? size[1.0]
                            : k.adSKRate < 55
                            ? size[0.25]
                            : k.adSKRate < 30
                            ? size[0.55]
                            : size[0.85],
                        // 平均利用率
                        uitilizationRate: l.uitilizationRate,
                        cityCenter: { lng: l.lng, lat: l.lat },
                        click: (e) => {
                          // 点击事件
                        },
                      });
                    }
                    let column4 = configMap[3].value;
                    let tempLeaf = {};
                    column4.forEach((item) => {
                      tempLeaf[item] = l[item];
                    });
                    // tempLeaf.key = lIndex;
                    // tempLeaf.sort = lIndex + 1;
                    let sortLIndex = tempChild[forth].length;
                    tempLeaf.key = sortLIndex;
                    tempLeaf.sort = sortLIndex + 1;
                    tempChild[forth].push(tempLeaf);
                    // 设置地图上的点位坐标
                    callBack && callBack(l);
                  });
                }
                let sortKIndex = tempParent[third].length;
                tempChild.key = sortKIndex;
                tempChild.sort = sortKIndex + 1;
                tempParent[third].push(tempChild);
              });
            }
            let sortIndex = resTableData.length;
            tempParent.key = sortIndex;
            tempParent.sort = sortIndex + 1;
            resTableData.push(tempParent);
          });
        }
      });
      return resTableData;
    },
    // tab切换时触发
    switchTab(key) {
      this.currentTab = key;
      switch (key) {
        case "1":
          if ((flag & 8) == 8 && instanceMap1) {
            return;
          } else {
            this.getReport(
              new Map([["getDeviceCountReport", { type: "map" }]])
            );
            let timer1 = setTimeout(() => {
              this.pointsDistribution();
              clearTimeout(timer1);
            }, 100);
          }
          break;
        case "2":
          if ((flag & 4) == 4 && instanceMap2) {
            return;
          } else {
            this.getReport(
              new Map([["getVariousRateReport", { type: "map" }]])
            );
            let timer2 = setTimeout(() => {
              this.pointUtilization();
              clearTimeout(timer2);
            }, 100);
          }
          break;
        case "3":
          if ((flag & 2) == 2 && instanceMap3) {
            return;
          } else {
            this.getReport(new Map([["getWFSCountReport", { type: "map" }]]));
            let timer3 = setTimeout(() => {
              this.pointVisibleRate();
              clearTimeout(timer3);
            }, 100);
          }
          break;
        case "4":
          if ((flag & 1) == 1 && instanceMap4) {
            return;
          } else {
            this.getReport(
              new Map([
                ["getOnPubPlanReport", { type: "map" }],
                // ["getAdPlanDirectionReport", { type: "map" }],
              ])
            );
            let timer4 = setTimeout(() => {
              this.adPush(mapData4["countryDirectionList"]);
              clearTimeout(timer4);
            }, 100);
          }
          break;
        default:
          break;
      }
    },
    // 高德地图点位分布
    pointsDistribution() {
      if (!instanceMap1) {
        instanceMap1 = initMap({
          id: "map_container",
          tilt: 48.8,
          heading: 0,
          center: [105.348145, 28.165926],
          zoom: 11,
          style: whiteStyle,
        });
        instanceMap1.on("zoomend", (e) => {
          let level = e.target.getZoom();
          this.sliderValue1 = this.getSliderValue(level);
        });

        var loca1 = new Loca.Container({ map: instanceMap1 });

        layer1 = new Loca.ScatterLayer({
          zIndex: 10,
          opacity: 0.8,
          visible: true,
          zooms: [2, 22],
        });
        loca1.add(layer1);

        layer3 = new Loca.ScatterLayer({
          zIndex: 9,
          opacity: 0.4,
          visible: true,
          zooms: [2, 22],
        });
        loca1.add(layer3);

        layer4 = new Loca.PointLayer({
          zIndex: 11,
          opacity: 0.5,
          visible: true,
          zooms: [2, 22],
        });
        loca1.add(layer4);
      }
      flag |= 8;
    },
    // 点位利用率
    pointUtilization(clusterData = mapData2.province) {
      // 高德地图API功能
      if (!instanceMap2) {
        instanceMap2 = new AMap.Map("map_container2", {
          resizeEnable: true,
          scrollWheel: true,
          mapStyle: 'amap://styles/whitesmoke',
        });
        instanceMap2.setCenter([105.348145, 28.165926]);
        instanceMap2.setZoom(5);
        instanceMap2.currentScaleLevel = 5;
        instanceMap2.addControl(new AMap.Scale());
        instanceMap2.on("zoomend", (e) => {
          let level = e.target.getZoom(),
            currentScaleLevel = instanceMap2.currentScaleLevel;
          this.sliderValue2 = this.getSliderValue(level);
          if (level < 6) {
            currentScaleLevel >= 6 && this.pointUtilization(mapData2.province);
          } else if (level < 10) {
            (currentScaleLevel >= 10 || currentScaleLevel < 6) &&
              this.pointUtilization(mapData2.city);
          } else if (level < 13) {
            (currentScaleLevel >= 13 || currentScaleLevel < 10) &&
              this.pointUtilization(mapData2.district);
          } else {
            currentScaleLevel < 13 && this.pointUtilization(mapData2.area);
          }
          instanceMap2.currentScaleLevel = level;
        });
      }
      // 清除之前的覆盖物
      map2Overlays.forEach((overlay) => instanceMap2.remove(overlay));
      map2Overlays = [];
      clusterData.forEach((item) => {
        if (item.cityCenter && item.cityCenter.lng && item.cityCenter.lat) {
          // 三色区间 rgb(195, 219, 241) rgb(24, 144, 255) R:171 G:75 B:14 A:0.5
          let colorR = 195 - Math.floor((171 * item.uitilizationRate) / 100),
            colorG = 219 - Math.floor((75 * item.uitilizationRate) / 100),
            colorB = 241 + Math.floor((14 * item.uitilizationRate) / 100),
            colorA = 0.8 + ((0.2 * item.uitilizationRate) / 100).toFixed(2) * 1;
          let text = new AMap.Text({
            text: item.uitilizationRate + '%',
            position: new AMap.LngLat(item.cityCenter.lng, item.cityCenter.lat),
            offset: new AMap.Pixel(22, 2),
            style: {
              width: item.size,
              height: item.size,
              borderRadius: '50%',
              border: 'none',
              textAlign: 'center',
              lineHeight: item.size,
              background: `rgba(${colorR}, ${colorG}, ${colorB}, ${colorA})`,
              color: '#fff',
              'box-shadow': '0px 0px 2px',
              'box-sizing': 'content-box',
            },
          });
          text.cityCenter = item.cityCenter;
          text.on('click', item.click);
          instanceMap2.add(text);
          map2Overlays.push(text);
        }
      });
      flag |= 4;
    },
    // 点位曝光率
    pointVisibleRate() {
      if (!instanceMap3) {
        // 高德地图API功能
        instanceMap3 = new AMap.Map("map_container3", {
          resizeEnable: true,
          scrollWheel: true,
          mapStyle: 'amap://styles/whitesmoke',
        });
        instanceMap3.setCenter([105.348145, 28.165926]);
        instanceMap3.setZoom(5);
        instanceMap3.on("zoomend", (e) => {
          let level = e.target.getZoom();
          this.sliderValue3 = this.getSliderValue(level);
        });
        instanceMap3.addControl(new AMap.Scale());

        // 使用Loca热力图图层
        var loca3 = new Loca.Container({ map: instanceMap3 });
        dataSet3 = new Loca.HeatMapLayer({
          zIndex: 10,
          opacity: 1,
          visible: true,
          zooms: [2, 22],
          config: {
            radius: 13,
            gradient: {
              0.25: [0, 0, 255, 1],
              0.55: [0, 255, 0, 1],
              0.85: [255, 255, 0, 1],
              1.0: [255, 0, 0, 1],
            },
            value: function (index, feature) {
              return feature.count || 0;
            },
            max: 100,
          },
        });
        loca3.add(dataSet3);
      }
      flag |= 2;
    },
    // 广告投放
    adPush(directionArr = []) {
      if (!instanceMap4) {
        instanceMap4 = initMap({
          id: "map_container4",
          tilt: 41.8,
          heading: 0,
          center: [105.348145, 28.165926],
          zoom: 5,
          style: whiteStyle,
        });
        instanceMap4.on("zoomend", (e) => {
          let level = e.target.getZoom();
          this.sliderValue4 = this.getSliderValue(level);
        });
        var loca4 = new Loca.Container({ map: instanceMap4 });
        lineLayer1 = new Loca.LineLayer({
          zIndex: 10,
          opacity: 0.8,
          visible: true,
          zooms: [2, 22],
          style: {
            color: 'rgba(195, 233, 245, 0.8)',
            lineWidth: 1.5,
          },
        });
        lineLayer2 = new Loca.LineLayer({
          zIndex: 9,
          opacity: 0.6,
          visible: true,
          zooms: [2, 22],
          style: {
            color: 'rgba(17, 95, 255, 0.6)',
            lineWidth: 1,
          },
        });
        loca4.add(lineLayer1);
        loca4.add(lineLayer2);
      }

      // 生成曲线数据
      var data = [];
      directionArr.forEach((item) => {
        // 简单的贝塞尔曲线插值
        var start = item.startPoint;
        var end = item.endPoint;
        var midLng = (start[0] + end[0]) / 2;
        var midLat = (start[1] + end[1]) / 2 + Math.abs(start[0] - end[0]) * 0.15;
        var coords = [];
        for (var t = 0; t <= 1; t += 1 / 30) {
          var lng = (1 - t) * (1 - t) * start[0] + 2 * (1 - t) * t * midLng + t * t * end[0];
          var lat = (1 - t) * (1 - t) * start[1] + 2 * (1 - t) * t * midLat + t * t * end[1];
          coords.push([lng, lat]);
        }
        data.push({
          geometry: {
            type: 'LineString',
            coordinates: coords,
          },
          properties: {
            count: Math.random(),
          },
        });
      });

      lineLayer1.setData(data);
      lineLayer2.setData(data);
      flag |= 1;
    },
    // 切换城市视角
    changeMapCity1(record) {
      let cityCenter = getCenterByCityName(record.cityName);
      cityCenter &&
        instanceMap1.setZoomAndCenter(
          12,
          new AMap.LngLat(cityCenter.lng, cityCenter.lat)
        );
    },
    changeMapCity2(record) {
      instanceMap2.setCity(normalizeCityName(record.cityName));
      instanceMap2.setZoom(9);
    },
    changeMapCity3(record) {
      instanceMap3.setCity(normalizeCityName(record.cityName));
      instanceMap3.setZoom(12);
    },
    changeMapCity4(record) {
      let cityCenter = getCenterByCityName(record.cityName);
      cityCenter &&
        instanceMap4.setZoomAndCenter(
          10,
          new AMap.LngLat(cityCenter.lng, cityCenter.lat)
        );
      // 设置城市视角数据
      this.adPush(mapData4["cityDirectionList"][record.cityId]);
    },
    // 地图4切换为全国视角
    countryDirection() {
      instanceMap4.setZoomAndCenter(5, new AMap.LngLat(105.348145, 28.165926));
      this.adPush(mapData4["countryDirectionList"]);
    },
    // 排序
    bubbleSort(arr, sortColumn, changeColumn) {
      if (Array.isArray(arr)) {
        for (var i = arr.length - 1; i > 0; i--) {
          for (var j = 0; j < i; j++) {
            if (arr[j][sortColumn] < arr[j + 1][sortColumn]) {
              [arr[j], arr[j + 1]] = [arr[j + 1], arr[j]];
              [arr[j][changeColumn], arr[j + 1][changeColumn]] = [
                arr[j + 1][changeColumn],
                arr[j][changeColumn],
              ];
            }
          }
        }
      }
    },
  },
};
</script>

<style>
.company-popover .ant-popover-inner-content {
  padding: 12px 6px 12px 16px;
}
</style>

<style lang="scss" scoped>
/deep/ .ant-slider-vertical .ant-slider-mark-text {
  left: -60px;
  font-size: 12px;
}
.search-content {
  max-height: 300px;
  overflow-y: auto;
}
.company-name {
  font-size: 14px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.65);
  line-height: 32px;
  cursor: pointer;
  &:hover {
    color: #1890ff;
  }
}
.ant-dropdown-link {
  color: #000000d9;
}
.closing-data {
  margin-left: 33px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.45);
  line-height: 32px;
}
.extra-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  .active-type {
    color: #1890ff;
  }
  .extra-item {
    display: inline-block;
    margin-right: 24px;

    a {
      margin-left: 24px;
    }
  }
}

.antd-pro-pages-dashboard-analysis-twoColLayout {
  position: relative;
  display: flex;
  display: block;
  flex-flow: row wrap;
}

.antd-pro-pages-dashboard-analysis-salesCard {
  height: calc(100% - 24px);
  /deep/ .ant-card-head {
    position: relative;
  }
}

.dashboard-analysis-iconGroup {
  i {
    margin-left: 16px;
    color: rgba(0, 0, 0, 0.45);
    cursor: pointer;
    transition: color 0.32s;
    color: black;
  }
}
.analysis-salesTypeRadio {
  position: absolute;
  right: 54px;
  bottom: 12px;
}
.map-tab {
  min-height: 500px;
}
.point-map {
  padding: 0 0 24px 24px;
  overflow: hidden;
}
.row-in-tab {
  display: flex;
  flex-direction: row;
  padding: 0 32px 32px;
}
.map-wrap-full {
  position: fixed !important;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 100% !important;
  z-index: 1000;
}
.map-wrap {
  position: relative;
  flex-grow: 1;
  /* min-height: 551px; */
  height: 551px;
  margin-right: 24px;
  .map-container {
    height: 100%;
  }
  .fad-map-info {
    position: absolute;
    top: 12px;
    right: 0;
    left: 0;
    width: 85%;
    height: 32px;
    padding: 0 17px;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 4px;
    display: flex;
    margin: 0 auto 0 12px;
    align-items: center;
    justify-content: flex-start;
    flex-flow: row nowrap;
    font-size: 14px;
    font-weight: 400;
    color: #ffffff;
    z-index: 1000;
    .info-text {
      margin-left: 4px;
      line-height: 22px;
    }
    .info-close {
      margin: 0 0 0 auto;
    }
  }
  .fad-map-control {
    position: absolute;
    top: 20px;
    right: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-flow: column;
    height: 500px;
    z-index: 1000;
    .map-full-screen {
      font-size: 25px;
      margin-bottom: 28px;
      cursor: pointer;
    }
    .zoom-btn {
      width: 25px;
      height: 25px;
      margin-top: 2px;
      border-radius: 2px;
      background: #fff;
      text-align: center;
      i.anticon {
        vertical-align: middle;
      }
    }
  }
  /deep/ .amap-logo,
  /deep/ .amap-copyright {
    display: none !important;
  }
  /deep/ .amap-scalecontrol {
    position: absolute;
    overflow: hidden;
  }
}

.salesCard /deep/ .ant-tabs-nav .ant-tabs-tab-active {
  font-weight: 600;
}
</style>
